/** Main project script */

// ensure the main object is defined
if (typeof(so) === 'undefined') {
    var so = {};
}

// main code
so.project = {
    init: function () {
        so.project.navigation.init();
        so.project.mmenu();
        so.project.initSwipeBox();
        so.project.featuredProductModalInit();

        // if(jQuery('.user-form').length > 0) {
        //     jQuery('.user-form input.text').jvFloat();
        //     jQuery('.user-form textarea').jvFloat();
        // }

        if(jQuery('.video-item').length > 0) {
            so.project.videoplayer.init();
        }
    },

    featuredProductModalInit: function() {
        const modal = $('#featured-product-modal');
        if (modal.length) {

            //find the delay time
            const delay = Number(modal.data('delayseconds') * 1000);
            setTimeout(function () {
                so.project.featuredProductModalOpen();
            }, delay );
        }
    },

    featuredProductModalOpen: function() {
        //data-repeat is set in the cms to force the modal to always show
        //otherwise, a cookie can be set to show modal only once
        if ($('#featured-product-modal').data('repeat') ||
            !document.cookie.split('; ').find(row => row.startsWith('featuredModalDismissed'))) {
            //listen for clicks to close
            $('#featured-product-modal .close').on('click',so.project.featuredProductModalClose );
            //toggle the modal as open
            $('#featured-product-modal').modal('show');
        } else {
            console.log('modal not opening as cookie set');
        }
    },

    featuredProductModalClose: function() {
        //toggle the modal as open
        $('#featured-product-modal').modal('hide');
        //set cookie to not show the modal.
        document.cookie = 'featuredModalDismissed=true; path=/';
    },

    mmenu: function() {
        $('#mmenu').mmenu({
            "offCanvas": {
                "position": "right"
            },
        });

        var api = $("#mmenu").data("mmenu");

        api.bind("open:start", function() {
            $('.hamburger-icon').addClass('open');
        });


        api.bind( "close:start", function() {
            $('.hamburger-icon').removeClass('open');
        });
    },

    initSwipeBox: function() {
        jQuery('.swipebox').swipebox({
            loopAtEnd: true,
            hideBarsDelay : 0
        });
    },

    navigation: {
        init: function() {
            jQuery('.nav-group').on('click', so.project.navigation.menuToggle);
        },

        menuToggle: function() {
            var menuItem = jQuery(this);
            if(menuItem.hasClass('active'))
            {
                menuItem.removeClass('active');
            }
            else
            {
                jQuery('.nav-group.active').removeClass('active');
                menuItem.addClass('active');
            }
        }
    },

    videoplayer: {
        init: function () {
            jQuery('.video-item').on('click', so.project.videoplayer.itemClick);
            jQuery('.video-player-container .close-button').on('click', so.project.videoplayer.closeClick);
        },

        itemClick: function () {
            var videoID = jQuery(this).data('id');
            var videoType = jQuery(this).data('videotype');
            var url = "";
            var iframe = "";

            if (videoType == 'yt') {
                url = 'https://www.youtube.com/embed/' + videoID + '?rel=0';
                iframe = '<iframe width="100%" height="100%" src="' + url + '" frameborder="0"></iframe>';
            } else if (videoType == 'vimeo') {
                url = "https://player.vimeo.com/video/" + videoID;
                iframe = '<iframe src="' + url + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
            }

            jQuery('.video-player-container').css('top', document.documentElement.scrollTop + 'px');
            jQuery('.video-player-container').toggleClass('active');
            jQuery('.video-player-container .media-wrapper').html(iframe);
            jQuery('body').css('overflow', 'hidden');

        },

        closeClick: function () {
            var videoContainer = jQuery('.video-player-container');
            videoContainer.toggleClass('active');

            jQuery('.video-player-container .media-wrapper').html('');
            jQuery('body').css('overflow', 'auto');
        }
    }
};

$(document).ready(function () {
    so.project.init();
});
